import { NgModule } from "@angular/core";
import {  RouterModule, Routes } from "@angular/router";
import { environment } from "../environments/environment";
import { PersonalProfileComponent } from "./components/account-settings/personal-profile/personal-profile.component";
import { BussinessPostComponent } from './components/bussiness-post/bussiness-post.component';
import { BusinessAdminComponent } from "./components/bussinesspages/business-admin/business-admin.component";
import { BusinessAnalyticsComponent } from "./components/bussinesspages/business-analytics/business-analytics.component";
import { BusinessCommunityComponent } from './components/bussinesspages/business-community/business-community.component';
import { BusinessEmployeeRequestsComponent } from './components/bussinesspages/business-employee-requests/business-employee-requests.component';
import { BusinessEmployeeComponent } from './components/bussinesspages/business-employee/business-employee.component';
import { BusinessFollowerComponent } from './components/bussinesspages/business-follower/business-follower.component';
import { BusinessFollowersRequestSentComponent } from './components/bussinesspages/business-followers-request-sent/business-followers-request-sent.component';
import { BusinessFollowersRequestComponent } from './components/bussinesspages/business-followers-request/business-followers-request.component';
import { BusinessJobsComponent } from './components/bussinesspages/business-jobs/business-jobs.component';
import { BusinessProfileComponent } from "./components/bussinesspages/business-profile/business-profile.component";
import { BusinessSecuritySettingsComponent } from './components/bussinesspages/business-security-settings/business-security-settings.component';
import { BusinessComponent } from "./components/bussinesspages/business/business.component";
import { CreateBusinessComponent } from "./components/bussinesspages/create-business/create-business.component";
import { DeactivateBusinessComponent } from './components/bussinesspages/deactivate-business/deactivate-business.component';
import { AnalyticsComponent } from './components/bussinesspages/user-management/analytics/analytics.component';
import { BusinessContactsComponent } from './components/bussinesspages/user-management/business-contacts/business-contacts.component';
import { BusinessNetworksComponent } from './components/bussinesspages/user-management/business-networks/business-networks.component';
import { CustomerBillingComponent } from './components/bussinesspages/user-management/customer-billing/customer-billing.component';
import { CustomerContactComponent } from './components/bussinesspages/user-management/customer-contact/customer-contact.component';
import { CustomerDetailComponent } from './components/bussinesspages/user-management/customer-detail/customer-detail.component';
import { CustomerInteractionComponent } from './components/bussinesspages/user-management/customer-interaction/customer-interaction.component';
import { CustomerJobsComponent } from './components/bussinesspages/user-management/customer-jobs/customer-jobs.component';
import { CustomerNetworkComponent } from './components/bussinesspages/user-management/customer-network/customer-network.component';
import { NetworkDetailsComponent } from './components/bussinesspages/user-management/customer-network/network-details/network-details.component';
import { CustomerPlanComponent } from './components/bussinesspages/user-management/customer-plan/customer-plan.component';
import { CustomerUserComponent } from './components/bussinesspages/user-management/customer-user/customer-user.component';
import { CustomerWorkspaceComponent } from './components/bussinesspages/user-management/customer-workspace/customer-workspace.component';
import { WorkspaceDetailsComponent } from './components/bussinesspages/user-management/customer-workspace/workspace-details/workspace-details.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { CommunityCreateComponent } from "./components/communitypages/community-create/community-create.component";
import { CommunityComponent } from "./components/communitypages/community/community.component"; 
import { FaqComponent } from './components/faq/faq.component'; 
import { HelpModuleComponent } from './components/help-module/help-module.component';
import { HelpSearchComponent } from './components/help-search/help-search.component';
import { LandingPageComponent } from "./components/landing-page/landing-page.component";
import { MembersDirectoryComponent } from "./components/members-directory/members-directory.component";
import { InviteMemberComponent } from "./components/networkpages/invite-member/invite-member.component";
import { NetAboutpageComponent } from "./components/networkpages/net-aboutpage/net-aboutpage.component";
import { NetHomepageComponent } from "./components/networkpages/net-homepage/net-homepage.component";
import { NetMemberspageComponent } from "./components/networkpages/net-memberspage/net-memberspage.component";
import { NetNetworkComponent } from "./components/networkpages/net-network/net-network.component";
import { NewMessagePageComponent } from "./components/new-message-page/new-message-page.component";
import { NotificationComponent } from "./components/notification/notification.component";
import { PlanUsageTrackingComponent } from './components/plan-usage-tracking/plan-usage-tracking.component';
import { PlanFeatureComponent } from './components/Price-subscritions/plan_feature/plan-feature/plan-feature.component';
import { PlanQuotaComponent } from './components/Price-subscritions/plan_quota/plan-quota/plan-quota.component';
import { PriceAddOnComponent } from './components/Price-subscritions/price-add-on/price-add-on.component';
import { PriceBackButtonenableComponent } from './components/Price-subscritions/price-back-buttonenable/price-back-buttonenable.component';
import { PriceTableComponent } from './components/Price-subscritions/price-table/price-table.component';
import { SeachtagsComponent } from './components/Search-list-UI/seachtags/seachtags.component';
import { SearchcandidateComponent } from './components/Search-list-UI/searchcandidate/searchcandidate.component';
import { SearchjobComponent } from './components/Search-list-UI/searchjob/searchjob.component';
import { SearchListComponent } from "./components/search-list/search-list.component";
 import { TeamAboutAsPageComponent } from "./components/TeamPages/team-about-as-page/team-about-as-page.component";
import { TeamHomePageComponent } from "./components/TeamPages/team-home-page/team-home-page.component";
import { TeamInviteSentComponent } from "./components/TeamPages/team-invite-sent/team-invite-sent.component";
import { TeamMembersPageComponent } from "./components/TeamPages/team-members-page/team-members-page.component";
import { TeamRoutePageComponent } from "./components/TeamPages/team-route-page/team-route-page.component";
import { UserClassificationComponent } from './components/user-classification/user-classification.component';
import { PageNotFoundComponent } from "./errorPage/page-not-found/page-not-found.component";
import { AfterLoginGuard, AuthGuard } from "./guard";
import { B2bNetworkConnectionComponent } from './page/homepage/b2b-network-connection/b2b-network-connection.component';
import { BusinessListComponent } from "./page/homepage/business-list/business-list.component";
import { NewCandidateComponent } from './page/homepage/candidate/new-candidate/new-candidate.component';
import { CommunityListComponent } from "./page/homepage/community-list/community-list.component";
import { ConnectionComponent } from "./page/homepage/connection/connection.component";
import { NewJobComponent } from './page/homepage/layout-jobs/new-job/new-job.component';
import { NetworkComponent } from "./page/homepage/network/network.component";
import { PostListComponent } from "./page/homepage/post-list/post-list.component";
import { TeamComponent } from "./page/homepage/team/team.component";
import { IndexLayoutComponent } from "./page/layout/index-layout/index-layout.component";
import { SuggestionsMenuComponent } from "./page/layout/suggestions-menu/suggestions-menu.component";
import { UserLayoutComponent } from "./page/layout/user-layout/user-layout.component";
import { WidgetComponent } from "./widget";
import { FeaturedJobsComponent } from './widget/featured-jobs/featured-jobs.component';
import { CustomerUserDetailsComponent } from './components/bussinesspages/user-management/customer-user-details/customer-user-details.component';
import { ContactDetailsComponent } from './components/bussinesspages/user-management/contact-details/contact-details.component';
import { BusinessNetworksDetailsComponent } from './components/bussinesspages/user-management/business-networks/business-networks-details/business-networks-details.component';
import { BusinessContactsDetailsComponent } from './components/bussinesspages/user-management/business-contacts/business-contacts-details/business-contacts-details.component';
import { ManageBusinessContactComponent } from './components/bussinesspages/user-management/business-contacts/manage-business-contact/manage-business-contact.component';
import { NetworkofbusinessconnectionComponent } from './components/bussinesspages/user-management/business-networks/networkofbusinessconnection/networkofbusinessconnection.component';
import { ContactofbusinessconnectionsComponent } from './components/bussinesspages/user-management/business-contacts/contactofbusinessconnections/contactofbusinessconnections.component';
import { ManageBusinessnetworkComponent } from './components/bussinesspages/user-management/business-networks/manage-businessnetwork/manage-businessnetwork.component';
import { MembernetworkConnectionComponent } from './page/homepage/membernetwork-connection/membernetwork-connection.component';
import { ManageWorkspaceComponent } from './components/bussinesspages/user-management/manage-workspace/manage-workspace.component';
import { ManageNetworksComponent } from './components/bussinesspages/user-management/manage-networks/manage-networks.component';
import { SecuritySettingsComponent } from './components/security-settings/security-settings.component';
import { NotificationConfigComponent } from './components/notification-config/notification-config.component';
import { ReferralsComponent } from './components/credit/referrals/referrals.component';
import { MembershipCreditComponent } from './components/credit/membership-credit/membership-credit.component';
import { AppAccessComponent } from './components/app-access/app-access.component';
import {  businessDetailResolver } from './guard/business-details-guard.ts.service';
import { adminGuard, adminResolver } from './guard/adminResolver';
import { contractGuard, contractResolver } from './guard/contractResolver';
import { SignUpComponent } from './components/auth/sign-up/sign-up.component';
import { CustomerBusinessCandidatelistComponent } from "./components/bussinesspages/user-management/customer-business-candidatelist/customer-business-candidatelist.component";
import { CustomerBusinessJoblistComponent } from "./components/bussinesspages/user-management/customer-business-joblist/customer-business-joblist.component";
import { L1InterviewComponent } from "./components/l1-interview/l1-interview.component";





const routes: Routes = [
  { path: "", redirectTo: "auth", pathMatch: "full" },
  { path: "widget", component: WidgetComponent },
  { path: "invite", component: SignUpComponent },
  { path: "changePassword", component: ChangePasswordComponent },
  { path: 'payment', loadChildren: () => import('./LazyLoadModule/Payment/successModule').then(m => m.SuccessModule) },
  
  // Feature Modules - Lazy Loaded
  { path: 'business', loadChildren: () => import('./features/business/business.routes').then(m => m.BUSINESS_ROUTES) },
  { path: 'newjobs', loadChildren: () => import('./features/jobs/jobs.routes').then(m => m.JOBS_ROUTES) },
  { path: 'newcandidates', loadChildren: () => import('./features/candidates/candidates.routes').then(m => m.CANDIDATES_ROUTES) },
  { path: 'job-center', loadChildren: () => import('./features/job-center/job-center.routes').then(m => m.JOB_CENTER_ROUTES) },
  { path: 'talent-center', loadChildren: () => import('./features/talent-center/talent-center.routes').then(m => m.TALENT_CENTER_ROUTES) },
  { path: 'talent-pools', loadChildren: () => import('./features/applicants/applicants.routes').then(m => m.APPLICANTS_ROUTES) },
  // Legacy redirect — old `/applicants` links (bookmarks, notifications, external
  // deep-links) continue to resolve to the renamed route.
  { path: 'applicants', redirectTo: 'talent-pools' },
  { path: 'teams', loadChildren: () => import('./features/teams/teams.routes').then(m => m.TEAMS_ROUTES) },
  { path: 'networks', loadChildren: () => import('./features/networks/networks.routes').then(m => m.NETWORKS_ROUTES) },
  { path: 'communities', loadChildren: () => import('./features/communities/communities.routes').then(m => m.COMMUNITIES_ROUTES) },
  { path: 'message', loadChildren: () => import('./features/messaging/messaging.routes').then(m => m.MESSAGING_ROUTES) },
  { path: 'user-management', loadChildren: () => import('./features/user-management/user-management.routes').then(m => m.USER_MANAGEMENT_ROUTES) },
  { path: 'notifications', loadChildren: () => import('./features/notifications/notifications.routes').then(m => m.NOTIFICATIONS_ROUTES) },
  {
    path: "",
    canActivateChild: [AfterLoginGuard],
    children: [
      { path: "auth", loadChildren: () => import('./LazyLoadModule/login/AuthModule').then(m => m.AuthModule)  },
      // { path: "signUp", component: SignUpComponent },
      // { path: "Forgotpassword", component: ForgotPasswordComponent },
      // { path: "setPassword", component: SignUpPage2Component, resolve: [ValidateTokenGuard] },
         { path: "invite", component: SignUpComponent },
      // { path: "verification", component: SocialMediaValidationComponent },
      // { path: "SetNewPassword", component: FogetPasswordAppUserComponent },
      // { path: "PasswordResetConfired", component: PasswordResetConfirmedComponent }
    ],
  }, 
  {
    path: "",
    component: UserLayoutComponent,
    canActivateChild: [AuthGuard],
    resolve : [businessDetailResolver],
    children: [
      {
        path: "landingPage",
        component: IndexLayoutComponent,
        // canDeactivate: [CanDeactivateGuard],
        children: [
          { path: "", component: LandingPageComponent, data: { fullWidth: true } },
          // Landing-page tabs — each URL drives the activeTab in the component.
          // `fullWidth: true` opts every tab out of the global `.app-container`
          // max-width so the sticky `.home-tabs-bar` extends the full viewport
          // edge-to-edge regardless of which tab is active. The dashboard tabs
          // use the full bleed for their grids; the activity feed tab keeps
          // its centered layout via a `max-width` on `.af-grid` itself
          // (see `styles/activity-feed.scss`).
          { path: "recruiter", component: LandingPageComponent, data: { fullWidth: true } },
          { path: "bench",     component: LandingPageComponent, data: { fullWidth: true } },
          { path: "feed",      component: LandingPageComponent, data: { fullWidth: true } },
          // { path: "dashboard", component: AppDashboradComponent },
          { path: "post", component: LandingPageComponent },
          { path: "connection", component: ConnectionComponent },
          { path: "network", component: NetworkComponent },
          { path: "team", component: TeamComponent },
          { path: "business", component: BusinessListComponent },
          { path: "b2bnetworkListing", component: B2bNetworkConnectionComponent },
          { path: "membernetworkListing", component: MembernetworkConnectionComponent },
          { path: "communityList", component: CommunityListComponent },
          { path: "post", component: PostListComponent },
        ],
      },

      {
        path: "networkPage",
        component: NetNetworkComponent,
        children: [
          { path: "home", component: NetHomepageComponent },
          { path: "aboutus", component: NetAboutpageComponent },
          { path: "members", component: NetMemberspageComponent },
          { path: "inviteSent", component: InviteMemberComponent },
        ],
      },
      {
        path: "teamPage",
        component: TeamRoutePageComponent,
        children: [
          { path: "home", component: TeamHomePageComponent },
          { path: "aboutus", component: TeamAboutAsPageComponent },
          { path: "members", component: TeamMembersPageComponent },
          { path: "inviteSent", component: TeamInviteSentComponent },
        ],
      },

      {
        path: "business",
        component: BusinessComponent,
        children: [
          { path: "about", component: BusinessProfileComponent },
          { path: "post", component: BussinessPostComponent },
          { path: "follower", component: BusinessFollowerComponent },
          { path: "followerRequest-received", component: BusinessFollowersRequestComponent },
          { path: "followerRequest-sent", component: BusinessFollowersRequestSentComponent },
          { path: "community", component: BusinessCommunityComponent },
          { path: "business-settings", component: BusinessSecuritySettingsComponent },
          { path: "employee", component: BusinessEmployeeComponent },
          { path: "employee-requests", component: BusinessEmployeeRequestsComponent },
          { path: "admin", component: BusinessAdminComponent },
          { path: "deactivate", component: DeactivateBusinessComponent },
          { path: "analytics", component: BusinessAnalyticsComponent },
          { path: "jobs", component: BusinessJobsComponent }
        ]
      },

      // Contract Center - MSA and Work Order management
      {
        path: 'contract-center',
        loadChildren: () => import('./LazyLoadModule/Contracts/ContractsModule').then(m => m.ContractsModule),
        canActivate: [contractGuard],
        resolve: { contractData: contractResolver },
        data: { fullWidth: true }
      },

      // Billing Center - Invoice and Payment management
      {
        path: 'billing-center',
        loadChildren: () => import('./LazyLoadModule/Billing/BillingModule').then(m => m.BillingModule),
        canActivate: [contractGuard],
        resolve: { contractData: contractResolver },
        data: { fullWidth: true }
      },

      {
        path: "user-management",
        component: CustomerDetailComponent,
        canActivate :[adminGuard],
        resolve : { data : adminResolver},
        data: { fullWidth: true },
        children: [
          { path: "plan", component: CustomerPlanComponent },
          { path: "user", component: CustomerUserComponent },
          { path: "interaction", component: CustomerInteractionComponent },
          { path: "jobs", component: CustomerJobsComponent },
          { path: "workSpace", component: CustomerWorkspaceComponent },
          { path: "network", component: CustomerNetworkComponent },
          { path: "settings", component: SecuritySettingsComponent },
          { path: "notiSettings", component: NotificationConfigComponent },
          { path: "referral", component: ReferralsComponent },
          { path: "credit", component: MembershipCreditComponent },
          { path: "appAccess", component: AppAccessComponent },

          {
            path: 'businessContacts',
            children: [
              {path: '',
                component: BusinessContactsComponent,
              },
              {
                path: 'businessConnectEdit',
                component: BusinessContactsDetailsComponent,
                data: {
                  breadCrumbs : [
                    { label: 'Business' , path : '/user-management/businessContacts' } ,
                    { label: 'Edit Business' , path : '/user-management/businessContacts/businessConnectEdit' } ,
                  ]
                }
              },
              {
                path: 'contactofbusinessconnection',
                component: ContactofbusinessconnectionsComponent,
                data: {
                  breadCrumbs : [
                    { label: 'Business' , path : '/user-management/businessContacts' } ,
                    { label: 'Manage Business' , path : '/user-management/managebusiness' } ,
                  ]
                }
              }
            ]
          },
          {
            path: 'businessNetworks',
            children: [
              {
                path: '',
                component: BusinessNetworksComponent,
              },
              {
                path: 'businessNetworkEdit',
                component: BusinessNetworksDetailsComponent,
                data: {
                  breadCrumbs : [
                    { label: 'Business Networks' , path : '/user-management/businessNetworks' } ,
                    { label: 'Edit Business Network' , path : '/user-management/businessNetworks/businessNetworkEdit' } ,
                  ]
                }
              },
              {
                path: 'networkofbusinessconnection',
                component: NetworkofbusinessconnectionComponent,
                data: {
                  breadCrumbs : [
                    { label: 'Business Networks' , path : '/user-management/businessNetworks' } ,
                    { label: 'View Business Network' , path : '/user-management/businessNetworks/networkofbusinessconnection' } ,
                  ]
                }
              }
            ]
          },
          { path: "businessNetworks", component: BusinessNetworksComponent },
          { path: "contacts", component: CustomerContactComponent },
          { path: "billing", component: CustomerBillingComponent },
          { path: "analytics", component: AnalyticsComponent },
          { path: 'businessNetworks/managebusinessnetwork', component: ManageBusinessnetworkComponent ,
            data: {
              breadCrumbs : [
                { label: 'Business Networks' , path : '/user-management/businessNetworks' } ,
                { label: 'Manage Business Networks' , path : '/user-management/businessNetworks/managebusinessnetwork' } ,
              ]
            }
          },
          { path: 'businessContacts/managebusiness', component: ManageBusinessContactComponent ,
            data: {
              breadCrumbs : [
                { label: 'Business' , path : '/user-management/businessContacts' } ,
                { label: 'Manage Business' , path : '/user-management/businessContacts/managebusiness' } ,
              ]
            }
           },
          { path: 'workSpace/details', component: WorkspaceDetailsComponent ,
            data: {
              breadCrumbs : [
                { label: 'Workspaces' , path : '/user-management/workSpace' } ,
                { label: 'Edit Workspace' , path : '/user-management/workSpace/details' } ,
              ]
            }
          },
          { path: 'workSpace/manageWorkspace', component: ManageWorkspaceComponent ,
            data: {
              breadCrumbs : [
                { label: 'Workspaces' , path : '/user-management/workSpace' } ,
                { label: 'Manage Workspaces' , path : '/user-management/workSpace/manageWorkspace' } ,
              ]
            }
          },
          { path: 'network/details', component: NetworkDetailsComponent,
            data: {
              breadCrumbs : [
                { label: 'Member Networks' , path : '/user-management/network' } ,
                { label: 'Edit Member Network' , path : '/user-management/network/details' } ,
              ]
            }
          },
          { path: 'network/manageNetwork', component: ManageNetworksComponent,
            data: {
              breadCrumbs : [
                { label: 'Member Networks' , path : '/user-management/network' } ,
                { label: 'Manage Networks' , path : '/user-management/network/manageNetwork' } ,
              ]
            }
          },
          { path: 'user/userDetails', component: CustomerUserDetailsComponent ,
            data: {
              breadCrumbs : [
                { label: 'Users' , path : '/user-management/user' } ,
                { label: 'Manage User Access' , path : '/user-management/user/userDetails' } ,
              ]
            }
           },
          { path: 'contacts/contactDetails', component: ContactDetailsComponent ,
            data: {
              breadCrumbs : [
                { label: 'Members' , path : '/user-management/contacts' } ,
                { label: 'Manage Members' , path : '/user-management/contacts/contactDetails' } ,
              ]
            }
          },

          // Business job and candidate, applicants route
          { path: "business-jobs", component: CustomerBusinessJoblistComponent },
          { path: "business-candidates", component: CustomerBusinessCandidatelistComponent },
          { path: "business-applicants", component: CustomerBusinessCandidatelistComponent },

        ]
      },

      { path: "faq", component: FaqComponent },
      { path: "help", component: HelpModuleComponent },
      { path: "helpSearch", component: HelpSearchComponent },
      { path: "planUsageTracking/:data", component: PlanUsageTrackingComponent },
      // { path: "checkout", component: CheckoutComponent },
      { path: "newcandidates", component : NewCandidateComponent, data: { fullWidth: true } },
      { path: "newjobs", component: NewJobComponent, data: { fullWidth: true } },
      { path: "userClassification", component: UserClassificationComponent },
      { path: "memberDirectory", component: MembersDirectoryComponent },
      { path: "suggestions", component: SuggestionsMenuComponent },
      { path: "personalProfile", component: PersonalProfileComponent },
      // { path: "PasswordResetConfired", component: PasswordResetConfirmedComponent },
      { path: "createBusiness", component: CreateBusinessComponent },
      { path: "Search-list", component: SearchListComponent },
      { path: "createCommunity", component: CommunityCreateComponent },
      { path: "community", component: CommunityComponent },
      { path: "featuredJob", component: FeaturedJobsComponent },
      { path: "message", component: NewMessagePageComponent },
      { path: "notification", component: NotificationComponent },
      { path: "clear", component: LandingPageComponent },
      { path: "searchjob", component: SearchjobComponent },
      { path: "seachcandidate", component: SearchcandidateComponent },
      { path: "Seachtags", component: SeachtagsComponent },
      { path: "plan-quota", component: PlanQuotaComponent },
      { path: "price-table", component: PriceTableComponent },
      { path: "price-seleted", component: PriceBackButtonenableComponent },
      { path: "plan-feature", component: PlanFeatureComponent },
      { path: "plan-addon", component: PriceAddOnComponent },
    ],
  },
  { path: "404", component: PageNotFoundComponent },
  { path: "l1-interview", component: L1InterviewComponent },
  { path: "**", redirectTo: "/auth/login", pathMatch: "full" },
];

// Export routes for standalone bootstrap
export { routes };

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: environment.useHash })],
  exports: [RouterModule],
})
export class AppRoutingModule {
  static components = [
  ]
}
